import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';
import { SelectButton } from "primereact/selectbutton";
import { Accordion, AccordionTab } from 'primereact/accordion';
import useFetchData from "hooks/useFetchDataWithDep";
//import Loading from "Components/Loading/Loading";
import TripsFilters from "../TripsFilters";
import DateRangeFilter from "../DateRangeFilter";

const LABELS_TRANSLATION = {
    'booked_trips': 'Courses réservées',
    'non_booked_trips': 'Courses non réservées'
};

const TripsStackedChart = () => {
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});
    const [selectedDrivers, setSelectedDrivers] = useState(null);
    const [selectedTaxis, setSelectedTaxis] = useState(null);
    const [dateBegin, setDateBegin] = useState(null);
    const [dateEnd, setDateEnd] = useState(null);
    const [aggregation, setAggregation] = useState('day');
    const [urlParams, setUrlParams] = useState('');
    const [activeIndex, setActiveIndex] = useState(null); // Fermé par défaut

    const aggregationOptions = [
        { label: 'Jour', value: 'day' },
        { label: 'Mois', value: 'month' },
        { label: 'Année', value: 'year' }
    ];

    useEffect(() => {
        let params = [];
        if (aggregation !== 'day') {
            params.push(`aggregate=${aggregation}`);
        }
        if (selectedDrivers?.length === 1) {
            params.push(`driver=${selectedDrivers[0].code}`);
        }
        if (selectedTaxis?.length === 1) {
            params.push(`taxi=${selectedTaxis[0].code}`);
        }
        if (dateBegin) {
            params.push(`date_begin=${dateBegin}`);
        }
        if (dateEnd) {
            params.push(`date_end=${dateEnd}`);
        }
        
        const newUrlParams = params.length > 0 ? `?${params.join('&')}` : '';
        console.log('URL Params:', newUrlParams);
        setUrlParams(newUrlParams);
    }, [aggregation, selectedDrivers, selectedTaxis, dateBegin, dateEnd]);

    const url = `/front/stackedBarStats/trips${urlParams}`;
    const { data: stackedData, isLoading } = useFetchData(url, null, urlParams);

    useEffect(() => {
        console.log('API Response:', stackedData); 
        const apiData = stackedData?.data?.results?.data;
        
        if (!apiData?.labels || !apiData?.datasets) {
            console.log('Données invalides ou manquantes');
            return;
        }

        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        const data = {
            labels: apiData.labels,
            datasets: apiData.datasets.map(dataset => ({
                ...dataset,
                label: LABELS_TRANSLATION[dataset.label] || dataset.label,
                borderColor: dataset.backgroundColor,
                borderWidth: 1
            }))
        };

        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                tooltip: {
                    mode: 'index',
                    intersect: false
                },
                legend: {
                    labels: {
                        color: textColor,
                        usePointStyle: true
                    }
                },
                title: {
                    display: true,
                    text: 'Répartition des courses réservées et non réservées',
                    color: textColor,
                    font: {
                        size: 16
                    }
                }
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary,
                        maxRotation: 10,
                        minRotation: 10
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
        };

        setChartData(data);
        setChartOptions(options);
    }, [stackedData]);

  //  if (isLoading) return <Loading />;

    const chartContent = (
        <div>
            <div className="flex flex-column gap-2">
                <div className="flex justify-content-between align-items-center">
                    <TripsFilters
                        selectedDrivers={selectedDrivers}
                        setSelectedDrivers={setSelectedDrivers}
                        selectedTaxis={selectedTaxis}
                        setSelectedTaxis={setSelectedTaxis}
                    />
                    <SelectButton 
                        value={aggregation} 
                        onChange={(e) => setAggregation(e.value)} 
                        options={aggregationOptions} 
                        className="p-buttonset-sm"
                        pt={{
                            button: ({ context }) => ({
                                style: {
                                    backgroundColor: context.selected ? '#ffdc45' : '#FFE87C',
                                    color: 'black',
                                    border: 'none',
                                    fontWeight: context.selected ? 'bold' : 'normal',
                                    transition: 'all 0.2s'
                                }
                            })
                        }}
                    />
                </div>
                <DateRangeFilter
                    dateBegin={dateBegin}
                    setDateBegin={setDateBegin}
                    dateEnd={dateEnd}
                    setDateEnd={setDateEnd}
                /> 
            </div>
            <div style={{ height: '400px', width: '100%', marginTop: '1rem' }}>
                <Chart type="bar" data={chartData} options={chartOptions} className="h-30rem" />
            </div>
        </div>
    );

    return (
        <div className="pt-4">
            <Accordion activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <AccordionTab header={<span style={{ color: '#000000' }}>Comparaison des courses réservées et non réservées</span>}>
                    {chartContent}
                </AccordionTab>
            </Accordion>
        </div>
    );
};

export default TripsStackedChart; 